import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogContainerComponent } from './confirm-dialog-container.component';
import { LineBasedConfirmDialogComponent } from './line-based-confirm-dialog.component';
import { SimpleConfirmDialogComponent } from './simple-confirm-dialog.component';
import { LayoutRowModule } from '../../directives/layout-row/layout-row.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingModule } from '../loading/loading.module';


@NgModule({
    declarations: [
        ConfirmDialogContainerComponent,
        SimpleConfirmDialogComponent,
        LineBasedConfirmDialogComponent
    ],
    imports: [
        CommonModule,
        LayoutRowModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        LoadingModule
    ],
    exports: [
        ConfirmDialogContainerComponent,
        SimpleConfirmDialogComponent,
        LineBasedConfirmDialogComponent
    ]
})
export class ConfirmDialogModule {
}
